import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { ShadowlessElement } from '@blocksuite/std';
import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

import type { Group } from '../../../../../../core/group-by/trait';
import { LEFT_TOOL_BAR_WIDTH, STATS_BAR_HEIGHT } from '../../../../consts';
import type { VirtualTableViewUILogic } from '../../../table-view-ui-logic';

const styles = css`
  affine-database-virtual-column-stats {
    margin-left: ${LEFT_TOOL_BAR_WIDTH}px;
    height: ${STATS_BAR_HEIGHT}px;
    display: flex;
  }
`;

export class VirtualDataBaseColumnStats extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  static override styles = styles;

  protected override render() {
    this.dataset.hasCalculations =
      this.tableViewLogic.view.computedProperties$.value.some(
        column => !!column.statCalcType
      )
        ? 'true'
        : 'false';
    const cols = this.tableViewLogic.layoutSnapshot$.value.dataColumns.map(
      column => column.property
    );
    return html`
      ${repeat(
        cols,
        col => col.id,
        col => {
          return html`<affine-database-virtual-column-stats-cell
            .column=${col}
            .group=${this.group}
          ></affine-database-virtual-column-stats-cell>`;
        }
      )}
    `;
  }

  @property({ attribute: false })
  accessor group: Group | undefined = undefined;

  @property({ attribute: false })
  accessor tableViewLogic!: VirtualTableViewUILogic;
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-database-virtual-column-stats': VirtualDataBaseColumnStats;
  }
}
